const subscriptionSettingsKeys = {
  "subscription.settings.manage.payment-required":
    "Actualiza tu información de pago en la sección Detalles de pago de abajo antes de gestionar tu suscripción.",
  "subscription.settings.cancel.scheduled": "Tu suscripción ya está programada para finalizar. No se renovará.",
  "subscription.settings.address.label": "Dirección de facturación",
  "subscription.settings.address.description": "Actualiza el nombre y la dirección utilizados para la facturación.",
  "subscription.settings.address.unavailable": "Necesitas una cuenta de facturación para actualizar tu dirección.",
  "subscription.settings.address.load-error": "No pudimos cargar tu dirección de facturación. Inténtalo de nuevo.",
  "subscription.settings.address.save-error": "No pudimos guardar tu dirección de facturación. Revisa la dirección e inténtalo de nuevo.",
  "subscription.settings.address.retry": "Intentar de nuevo",
  // Section Headers
  "subscription.settings.billing": "Facturación",

  // Manage Subscription
  "subscription.settings.manage.label": "Gestionar suscripción",
  "subscription.settings.manage.description": "Agrega o elimina usuarios de tu suscripción.",

  // Cancel Subscription
  "subscription.settings.cancel.label": "Cancelar suscripción",
  "subscription.settings.cancel.description": "Cancela tu suscripción.",
  // Payment Details
  "subscription.settings.payment.label": "Detalles de pago",
  "subscription.settings.payment.description": "Actualiza tu método de pago.",
  "subscription.settings.payment.no-subscription": "Necesitas una suscripción activa para actualizar tu método de pago.",
};

export const subscriptionSettings = {
  ...subscriptionSettingsKeys,
};
